import type { Locale } from '@/types/regionTypes';

import type { SearchHit, StoreHit } from '@/integrations/algolia/types';

import { getTranslatedStoreValue } from '../StoresList/utils';

export function isSearchHit(hit: SearchHit): hit is SearchHit {
  return (hit as SearchHit).name !== undefined;
}

export const isStoreHit = (hit: unknown): hit is StoreHit => {
  return (
    typeof hit === 'object' &&
    hit !== null &&
    'appointments' in hit &&
    'city' in hit
  );
};
export function getHitName(hit: SearchHit, locale: Locale): string | undefined {
  let hitName;

  if (isStoreHit(hit)) {
    hitName =
      getTranslatedStoreValue(hit, 'name', locale.slug) ||
      getTranslatedStoreValue(hit, 'city', locale.slug);
  } else if (isSearchHit(hit)) {
    if (typeof hit.name === 'object' && hit.name !== null) {
      hitName = hit.name[locale.code.toUpperCase()] as string;
    } else if (typeof hit.name === 'string') {
      hitName = hit.name;
    }
  }
  return hitName;
}
